var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    stroke: "#000450",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    stroke: "inherit"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    d: "M16.5 8v16M8 15.5h16"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMzIgMzIiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzAwMDQ1MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTYiIGN5PSIxNiIgcj0iMTUuNSIgc3Ryb2tlPSJpbmhlcml0Ii8+CjxsaW5lIHgxPSIxNi41IiB5MT0iOCIgeDI9IjE2LjUiIHkyPSIyNCIgc3Ryb2tlPSJpbmhlcml0Ii8+CjxsaW5lIHgxPSI4IiB5MT0iMTUuNSIgeDI9IjI0IiB5Mj0iMTUuNSIgc3Ryb2tlPSJpbmhlcml0Ii8+Cjwvc3ZnPgo=";
export { SvgPlus as ReactComponent };